import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Alert, Button, Card, Chip, Stack, Typography } from "@mui/joy";
import { proposalDealsApi } from "../../lib/proposalDealsApi";

export default function OpportunityDealProposals({
  opportunity,
}: {
  opportunity: number;
}) {
  const query = useQuery({
    queryKey: ["proposal-deals", "opportunity", opportunity],
    queryFn: () =>
      proposalDealsApi.list(`opportunity=${opportunity}&page_size=100`),
  });
  return (
    <Card variant="outlined">
      <Stack direction="row" justifyContent="space-between" gap={2}>
        <Typography level="title-md">Insurance & Repair</Typography>
        <Button
          component={Link}
          to={`/crm/proposals/new?opportunity=${opportunity}`}
          size="sm"
        >
          Create proposal
        </Button>
      </Stack>
      {query.isError && (
        <Alert color="warning">
          Unable to load Insurance and Repair proposals.
        </Alert>
      )}
      {query.isPending && <Typography>Loading proposals…</Typography>}
      {query.data?.results.map((deal) => (
        <Button
          key={deal.id}
          component={Link}
          to={`/crm/proposals/deals/${deal.id}`}
          variant="soft"
          sx={{ justifyContent: "space-between", textAlign: "left", gap: 2 }}
        >
          <span>
            {deal.title}
            <br />
            {deal.proposal_number}
          </span>
          <Chip size="sm">{deal.status_label}</Chip>
        </Button>
      ))}
      {query.data?.count === 0 && (
        <Typography level="body-sm">
          No Insurance or Repair proposals yet.
        </Typography>
      )}
      {(query.data?.count || 0) > 100 && (
        <Button
          component={Link}
          to="/crm/proposals?deal_type=insurance"
          variant="plain"
        >
          View all proposals
        </Button>
      )}
    </Card>
  );
}
